import { API_BASE_URL } from "../app_url";

export const LOCAL_STORAGE_PREFIX = 'medgemma_';
export const MAX_LOCAL_HISTORY = 20;
export const idleTime = 90000; // 90 seconds

export const WAKEUP_COOLDOWN_MS = 60_000; // 60s
export const WAKEUP_TEXT = 'hello again medgamma';
export const WAKEUP_URL = '/chatbot/api-proxy.php';

export function extractTailQuery(html) {
  const txt = html
    .replace(/<\/?[^>]+(>|$)/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  const tail = txt.slice(-60);
  const match = tail.match(/([A-Za-zÀ-ÖØ-öø-ÿ0-9'’\- ]{2,})$/);
  return match ? match[1].trim() : "";
}

export const isValidSessionId = (id) => {
  return id && typeof id === 'string' && id.startsWith('sess_');
};

export const generateSessionId = () => {
  return 'sess_' + Date.now() + '_' + Math.random().toString(36).substring(2, 15);
};

export const fileToDataURL = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export function buildCompactContextText(uiMessages, maxTurns = 12) {
  const last = Array.isArray(uiMessages) ? uiMessages.slice(-maxTurns) : [];
  return last
    .map((m) => {
      const who = m.sender === "user" ? "User" : "Assistant";
      let content = m.text ?? "";
      if ((!content || content.trim() === "") && m.image) {
        content = "[Image shared]";
      }
      return `${who}: ${content.replace(/\n/g, " ").trim()}`;
    })
    .join("\n");
}

export const formatDateJJMMAAAA = (d) => {
  const dt = d ? new Date(d) : null;
  if (!dt || isNaN(dt)) return "";
  const dd = String(dt.getDate()).padStart(2,"0");
  const mm = String(dt.getMonth()+1).padStart(2,"0");
  const yyyy = dt.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
};

export const normalizeDocUrl = (item) => {
  if (!item) return null;
  let u = item.url || "";

  const apiBaseNoApi = API_BASE_URL.replace(/\/api\/?$/,'');

  if (u && u.startsWith("APP_URL=")) u = u.split("APP_URL=")[1];
  if ((!u || u === "") && item.path) {
    u = `${apiBaseNoApi.replace(/\/$/, '')}/storage/${item.path}`;
  }
  return u?.replace(/([^:]\/\/)\/+/g, "$1") || null;
};

export const preview = (s) => (typeof s === 'string' && s.length > 300 ? s.slice(0, 300) + '…' : s);
export const dbg = (...a) => console.log('[Exam]', ...a);

/**
 * Downloads a blob as a file with the specified filename
 * @param {Blob} blob - The blob to download
 * @param {string} filename - The filename to save as
 */
export const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

/**
 * Converts a base64 string to a Blob
 * @param {string} base64 - Base64 encoded string
 * @param {string} contentType - MIME type (e.g., 'application/pdf')
 * @returns {Blob}
 */
export const base64ToBlob = (base64, contentType = 'application/pdf') => {
  const binaryString = window.atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  
  return new Blob([bytes], { type: contentType });
};

export const resizeImage = (base64Image, maxWidth = 800, maxHeight = 800, quality = 0.8) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = function() {
      let width = img.width;
      let height = img.height;
      if (width > height) {
        if (width > maxWidth) {
          height = Math.round(height * maxWidth / width);
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width = Math.round(width * maxHeight / height);
          height = maxHeight;
        }
      }
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      const outputFormat = base64Image.startsWith('data:image/png') ? 'image/png' : 'image/jpeg';
      const resizedImage = canvas.toDataURL(outputFormat, outputFormat === 'image/png' ? undefined : quality);
      resolve(resizedImage);
    };
    img.onerror = () => {
      reject(new Error('Error loading image for resizing'));
    };
    img.src = base64Image;
  });
};
